import { render, staticRenderFns } from "./info-copy-item-modal.vue?vue&type=template&id=90c6a93a&scoped=true&"
import script from "./info-copy-item-modal.vue?vue&type=script&lang=js&"
export * from "./info-copy-item-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6a93a",
  null
  
)

export default component.exports